import { useAtomValue } from 'jotai'
import { aiGeneratedMediaIdsAtom } from './atoms'

export function useIsAiGeneratedImage(imageId: string | undefined | null): boolean {
	const aiGeneratedMediaIds = useAtomValue(aiGeneratedMediaIdsAtom)
	return !!imageId && aiGeneratedMediaIds.has(imageId)
}
